<template>
  <div
    class="employee-inner employee-inner-permission"
    :class="{'employee-inner-full' : tabActive}"
  >
    <ListInfo :loadData="loadData" :setup-panel="permissionList" @open-detail="openDetail('leave', $event)" @open-modal="openModal($event)" />

    <ListInfo :loadData="loadData" :setup-panel="trainingList" @open-detail="openDetail('training', $event)" @open-modal="openModal($event)" />

    <!-- Permission Leave -->
    <!-- <div class="leave-content">
      <div class="content-header">
        <p>Leave Permission</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Waiting for Approval</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (leaveWaiting.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (leaveWaiting.length != 0)" class="inner-list">
            <div v-for="data in leaveWaiting" :key="data" @click="openDetail(data)" class="inner-list-detail">
              <p>{{ data.transaction_no }}</p>
              <p>{{ data.info }}</p>
              <p>{{ formatDate('date', data.created_at) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('leaveWaiting', true, formatList(leaveWaitingfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-approve">
          <div class="inner-header">
            <p>Approved</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (leaveApprove.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (leaveApprove.length != 0)" class="inner-list">
            <div v-for="data in leaveApprove" :key="data" @click="openDetail(data)" class="inner-list-detail">
              <p>{{ data.transaction_no }}</p>
              <p>{{ data.info }}</p>
              <p>{{ formatDate('date', data.created_at) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('leaveApprove', true, formatList(leaveApprovefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Rejected</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (leaveReject.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (leaveReject.length != 0)" class="inner-list">
            <div v-for="data in leaveReject" :key="data" @click="openDetail(data)" class="inner-list-detail">
              <p>{{ data.transaction_no }}</p>
              <p>{{ data.info }}</p>
              <p>{{ formatDate('date', data.created_at) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('leaveReject', true, formatList(leaveRejectfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Training -->
    <!-- <div class="training-content">
      <div class="content-header">
        <p>Training</p>
      </div>

      <div class="content-subheader">
        <p>{{ thisMonthnow }}</p>
      </div>

      <div class="content-outer">
        <div class="content-inner content-inner-waiting">
          <div class="inner-header">
            <p>Waiting for Approval</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (trainingWaiting.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (trainingWaiting.length != 0)" class="inner-list">
            <div v-for="data in trainingWaiting" :key="data" class="inner-list-detail">
              <p>{{ data.organizer + " (" + data.venue + ")" }}</p>
              <p>{{ data.name }}</p>
              <p>{{ formatDate('event', data.start_date, data.end_date) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('trainingWaiting', true, formatList(trainingWaitingfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-approve">
          <div class="inner-header">
            <p>Approved</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (trainingApprove.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (trainingApprove.length != 0)" class="inner-list">
            <div v-for="data in trainingApprove" :key="data" class="inner-list-detail">
              <p>{{ data.organizer + " (" + data.venue + ")" }}</p>
              <p>{{ data.name }}</p>
              <p>{{ formatDate('event', data.start_date, data.end_date) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('trainingApprove', true, formatList(trainingApprovefull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>

        <div class="content-inner content-inner-reject">
          <div class="inner-header">
            <p>Rejected</p>
          </div>

          <div v-if="loadData" class="inner-list">
            <div v-show="loadData" v-for="data in 2" :key="data" class="inner-list-load"></div>
          </div>

          <div v-else-if="!loadData && (trainingReject.length == 0)" class="inner-list">
            <div class="inner-list-null">
              No data for this month!
            </div>
          </div>

          <div v-else-if="!loadData && (trainingReject.length != 0)" class="inner-list">
            <div v-for="data in trainingReject" :key="data" class="inner-list-detail">
              <p>{{ data.organizer + " (" + data.venue + ")" }}</p>
              <p>{{ data.name }}</p>
              <p>{{ formatDate('event', data.start_date, data.end_date) }}</p>
            </div>
          </div>

          <div class="buttons-container">
            <div @click="openModal('trainingReject', true, formatList(trainingRejectfull))" class="button-general button-primary" :class="{'button-frezee' : loadData}">
              <p>See All</p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
  /* eslint-disable */
  import { defineComponent, ref, reactive, onBeforeMount, onMounted, watch, watchEffect, computed } from "vue"
  import { useRouter, useRoute } from "vue-router"
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  import axios from 'axios'
  import dayjs from 'dayjs'

  import ListInfo from "./ListInfo.vue"

  export default {
    components: {
      ListInfo
    },

    props: {
      tabActive: { type: Boolean, default: false },
      loadData: { type: Boolean, default: false },
      thisMonthnow: { type: String, default: "" },
      leaveWaiting: { type: Object, default: [] },
      leaveWaitingfull: { type: Object, default: [] },
      leaveApprove: { type: Object, default: [] },
      leaveApprovefull: { type: Object, default: [] },
      leaveReject: { type: Object, default: [] },
      leaveRejectfull: { type: Object, default: [] },
      trainingWaiting: { type: Object, default: [] },
      trainingWaitingfull: { type: Object, default: [] },
      trainingApprove: { type: Object, default: [] },
      trainingApprovefull: { type: Object, default: [] },
      trainingReject: { type: Object, default: [] },
      trainingRejectfull: { type: Object, default: [] }
    },

    setup(props, { emit }) {
      const { t, locale } = useI18n()
      const router = useRouter()
      const route = useRoute()
      const store = useStore()
      const permissionList = ref({})
      const trainingList = ref({})


      const openDetail = (type, data) => {
        emit("open-detail", {type, data})
      }


      const openModal = (data) => {
        console.log("Cek ges", data)
        emit("open-modal", data)
      }


      onBeforeMount(() => {

      })

      onMounted(() => {

      })

      watchEffect(() => {
        if(
          props.leaveWaiting ||
          props.leaveWaitingfull ||
          props.leaveApprove ||
          props.leaveApprovefull ||
          props.leaveReject ||
          props.leaveRejectfull
        ) {
          permissionList.value = {
            id: "leave_permission_container",
            title: "Leave Permission",
            month: null,
            child: [
              {
                id: "leaveWaiting",
                title: "Waiting for Approval",
                container_color: 'yellow',
                dataShow: props.leaveWaiting,
                dataFull: props.leaveWaitingfull
              },
              {
                id: "leaveApprove",
                title: "Approved",
                container_color: 'green',
                dataShow: props.leaveApprove,
                dataFull: props.leaveApprovefull
              },
              {
                id: "leaveReject",
                title: "Rejected",
                container_color: 'red',
                dataShow: props.leaveReject,
                dataFull: props.leaveRejectfull
              }
            ]
          }
        }

        if(
          props.trainingWaiting ||
          props.trainingWaitingfull ||
          props.trainingApprove ||
          props.trainingApprovefull ||
          props.trainingReject ||
          props.trainingRejectfull
        ) {
          trainingList.value = {
            id: "training_container",
            title: "Training",
            month: null,
            child: [
              {
                id: "trainingWaiting",
                title: "Waiting for Approval",
                container_color: 'yellow',
                dataShow: props.trainingWaiting,
                dataFull: props.trainingWaitingfull
              },
              {
                id: "trainingApprove",
                title: "Approved",
                container_color: 'green',
                dataShow: props.trainingApprove,
                dataFull: props.trainingApprovefull
              },
              {
                id: "trainingReject",
                title: "Rejected",
                container_color: 'red',
                dataShow: props.trainingReject,
                dataFull: props.trainingRejectfull
              }
            ]
          }
        }
      })

      return {
        permissionList,
        trainingList,
        openDetail,
        openModal
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>
